import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent, trackPageView } from "@/lib/analytics";

function getTrackingTarget(element) {
  if (!(element instanceof Element)) return null;
  return element.closest("[data-track]");
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path, document.title);
  }, [location]);

  useEffect(() => {
    function handleClick(event) {
      const target = getTrackingTarget(event.target);
      if (!target) return;

      const eventName = target.getAttribute("data-track");
      if (!eventName) return;

      trackEvent(eventName, {
        page_path: `${window.location.pathname}${window.location.search}`,
        link_text: (target.textContent || "").trim().slice(0, 120),
        destination:
          target.getAttribute("href") ||
          target.getAttribute("to") ||
          target.getAttribute("data-destination") ||
          "",
      });
    }

    document.addEventListener("click", handleClick, true);
    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);

  return null;
}
